module.exports = __webpack_public_path__ + "img/20c9a08.jpg";